import DropdownPortal from "@/components/ui/DropdownPortal";
import { Product } from "@/redux/feature/videoDashboard/videoDashboardType";
import { ChevronRight, Clock, MoreVertical, Video } from "lucide-react";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const TableDesktopView = ({
  brand,
  setIsConfirmModalOpen,
  setSelectedBrand,
  isDeleting,
}: {
  brand: Product;
  setIsConfirmModalOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedBrand: Dispatch<SetStateAction<Product | null>>;
  isDeleting: boolean;
}) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const portalDropdownRef = useRef<HTMLDivElement | null>(null);

  const handleDropdownClick = (e: React.MouseEvent) => {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    setDropdownPosition({
      top: rect.bottom + 18,
      left: rect.left - 150,
    });
    setOpenDropdown((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedOutside =
        dropdownRef.current &&
        !dropdownRef.current.contains(target) &&
        portalDropdownRef.current &&
        !portalDropdownRef.current.contains(target);

      if (clickedOutside) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="hidden md:block">
      <div className="bg-white hover:bg-slate-50/50 transition-all duration-200 group-hover:shadow-sm overflow-visible relative">
        <div className="grid grid-cols-12 items-center px-8 py-6 gap-6">
          {/* Product Name */}
          <div className="col-span-3 min-w-0">
            <h4 className="font-semibold text-slate-900 text-base leading-tight mb-1">
              {brand?.productName}
            </h4>
            <p className="text-slate-600 text-sm font-medium">
              {brand?.category}
            </p>
          </div>

          {/* Status */}
          <div className="col-span-1 text-center">
            <span
              className={`inline-flex px-3 py-1.5 text-xs font-semibold rounded-full border capitalize ${
                brand.dataStatus === "ready"
                  ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                  : "bg-slate-50 text-slate-600 border-slate-200"
              }`}
            >
              {brand.dataStatus}
            </span>
          </div>

          {/* Brand videos */}
          <div className="col-span-2 text-center">
            <div className="bg-blue-50 rounded-lg p-3 inline-block border border-blue-100">
              <div className="flex items-center justify-center">
                <Video className="h-4 w-4 text-blue-600 mr-1" />
                <span className="text-sm font-bold text-slate-900">
                  {brand?.brandVideoCount || 0}
                </span>
              </div>
              <div className="text-xs text-blue-700 font-medium mt-1">
                Brand Videos
              </div>
            </div>
          </div>

          {/* Competitor videos */}
          <div className="col-span-2 text-center">
            <div className="bg-amber-50 rounded-lg p-3 inline-block border border-amber-100">
              <div className="flex items-center justify-center">
                <Video className="h-4 w-4 text-amber-600 mr-1" />
                <span className="text-sm font-bold text-slate-900">
                  {brand?.competitorVideoCount || 0}
                </span>
              </div>
              <div className="text-xs text-amber-700 font-medium mt-1">
                Competitors Videos
              </div>
            </div>
          </div>

          {/* Updated At */}
          <div className="col-span-2 text-center">
            <div className="flex items-center justify-center">
              <Clock className="h-4 w-4 text-slate-400 mr-2" />
              <span className="text-sm font-medium text-slate-700">
                {brand?.updatedAt} days ago
              </span>
            </div>
          </div>

          {/* Action button with dropdown */}
          <div className="col-span-2 text-right" ref={dropdownRef}>
            <Link
              to={`/product-collections/${brand.productId}/${encodeURIComponent(
                brand.brandName
              )}/${encodeURIComponent(brand.productName)}/${encodeURIComponent(
                brand.country
              )}`}
              className="inline-flex items-center px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-lg transition-all duration-200 hover:shadow-lg group whitespace-nowrap mr-2"
            >
              View Videos
              <ChevronRight className="h-4 w-4 ml-2 group-hover:translate-x-0.5 transition-transform" />
            </Link>

            {/* <button
              onClick={handleDropdownClick}
              className="p-2 rounded-full hover:bg-slate-200 transition"
            >
              <MoreVertical className="w-5 h-5 text-slate-600" />
            </button>
            {openDropdown && (
              <DropdownPortal
                position={dropdownPosition}
                onClickOutside={() => setOpenDropdown(false)}
              >
                <div className="w-40 bg-white border border-slate-200 rounded-lg shadow-lg">
                  <button
                    onClick={() => {
                      setIsConfirmModalOpen(true);
                      setSelectedBrand(brand);
                      setOpenDropdown(false);
                    }}
                    disabled={isDeleting}
                    className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                  >
                    Delete
                  </button>
                </div>
              </DropdownPortal>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableDesktopView;
